import { createGlobalStyle } from 'styled-components';
import { getColor } from '../../mixins/colors';
import { breakpoint } from '../../mixins/breakpoints';
import { cells } from '../../../styling/utils/grid';
import { text, fontFamilyBold } from '../../mixins/typography';

const NewsList = createGlobalStyle`
.news-section {
  .news-list {
    padding-top: 3.2rem;
    padding-bottom: 2.4rem;
    gap: 2.4rem;

    ${cells(1)}

      ${breakpoint('medium')} {
        ${cells(2)}
      }

      ${breakpoint('large')} {
        ${cells(3)}
      }

      ${breakpoint('xlarge')} {
        ${cells(4)}
      }

    ${breakpoint('medium')} {
      padding-top: 4rem;
      padding-bottom: 3.2rem;
    }

    ${breakpoint('large')} {
      padding-top: 4.8rem;
      padding-bottom: 4rem;
    }

    &__title {
      ${fontFamilyBold};
      line-height: 2.3rem;
      text-transform: uppercase;
      display: block;
      margin-top: 1.6rem;
    }

    &__info-container {
      ${text('medium')}
      color: ${getColor('grey', 600)};
      line-height: 2.1rem;
      text-transform: uppercase;
      margin-top: 0.8rem;
      margin-bottom: 0.8rem;
      display: block;
    }

    &__parent-title{
      margin-right: 0.8rem;
    }

    &__date{
      margin-left: 0.8rem;
    }

    &__intro {
      ${text('medium')}
      color: ${getColor('grey', 600)};
      line-height: 2.4rem;
      display: block;
    }

    &__link {
      ${text('medium')}
      ${fontFamilyBold};
      color: ${getColor('grey', 900)};
      line-height: 2.4rem;
      text-decoration-line: underline;
      text-transform: uppercase;
      margin-top: 1.6rem;
      display: block;
    }
  }

  .subnav__list {
    display: flex;
    gap: 1.6rem;
    overflow-x: auto;
    white-space: nowrap;
    margin-top: 3.6rem;

    ${breakpoint('large')} {
      flex-flow: row wrap;
      justify-content: center;
    }

    .subnav__item {
        border: 1px solid  ${getColor('grey', 300)};
        border-radius: 4px;
        padding: 0.8rem 1rem;

      .subnav__link {
        ${text('medium')}
        ${fontFamilyBold};
        color: ${getColor('grey', 900)};
        line-height: 2.4rem;
        letter-spacing: 0.5px;
        text-transform: uppercase;
      }
    }
  }
}
`;

export default NewsList;
